"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InjectionMapping = function () {
    function InjectionMapping(type, name, id) {
        (0, _classCallCheck3.default)(this, InjectionMapping);

        this._type = type;
        this._name = name;
        this._id = id;

        this._value = null;
        this._toType = null;
    }

    (0, _createClass3.default)(InjectionMapping, [{
        key: "_isValid",
        value: function _isValid() {
            return this._value != null || this._toType != null; // eslint-disable-line eqeqeq
        }
    }, {
        key: "_validateBeforeCreation",
        value: function _validateBeforeCreation() {
            if (this._isValid()) {
                throw new Error("Could not create mapping for " + this._id + " because it already has been defined");
            }

            return true;
        }
    }, {
        key: "toValue",
        value: function toValue(value) {
            if (!this._validateBeforeCreation()) {
                return;
            }

            this._value = value;
        }
    }, {
        key: "toType",
        value: function toType(type) {
            if (!this._validateBeforeCreation()) {
                return;
            }

            this._toType = type;
        }
    }, {
        key: "toSingleton",
        value: function toSingleton(Type) {
            this.toValue(new Type());
        }
    }, {
        key: "getValue",
        value: function getValue() {
            if (!this._isValid()) {
                throw new Error("Could not get value for " + this._id + " because the mapping is invalid");
            }

            if (this._value != null) {
                return this._value;
            } else if (this._toType != null) {
                // $FlowFixMe should define that it is a instantiable thing
                return new this._toType();
            }
        }
    }]);
    return InjectionMapping;
}();

exports.default = InjectionMapping;
//# sourceMappingURL=InjectionMapping.js.map